import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import Heading from 'LuxKit/Typography/Heading'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import React, { PropsWithChildren, ReactNode, useMemo } from 'react'
import styled from 'styled-components'
import AccommodationRoomDetailsList from '../AccommodationRoomDetailsList'
import LabelGroup from 'LuxKit/Label/LabelGroup'
import { isHotelPackage } from 'lib/offer/offerTypes'
import Clickable from 'components/Common/Clickable'
import { accommodationSameRoomTileGridChildEnforcer } from './AccommodationSameRoomTileGridBase'
import TextLink from 'LuxKit/TextLink'

export const StyledAccommodationSameRoomTileDetails = styled(Group)`
  ${accommodationSameRoomTileGridChildEnforcer}
  padding: ${rem(20)};
  min-width: 0;
`
interface Props {
  roomPackage: App.HotelPackage | App.BedbankPackage
  urgencyLabels?: ReactNode
  actions?: ReactNode
  roomCount: number
  onShowRoomDetails?: React.MouseEventHandler<HTMLButtonElement>
}

function AccommodationSameRoomTileDetails(props: PropsWithChildren<Props>) {
  const {
    actions,
    children,
    roomPackage,
    urgencyLabels,
    roomCount,
    onShowRoomDetails,
  } = props

  const name = useMemo(() => {
    if (isHotelPackage(roomPackage)) {
      return roomPackage.roomType.group?.name ?? roomPackage.roomType.name
    } else { // is App.BedbankPackage
      return roomPackage.name
    }
  }, [roomPackage])

  return <StyledAccommodationSameRoomTileDetails direction="vertical" gap={12}>
    <VerticalSpacer gap={4}>
      <Group direction="horizontal" horizontalAlign="space-between" gap={8}>
        <Heading variant="heading4">{roomCount > 1 && `${roomCount}x`} {name}</Heading>
        {actions && <Group direction="horizontal" gap={4} horizontalAlign="end" wrap="wrap" noDisplayWhenEmpty>
          {actions}
        </Group>}
      </Group>
      {urgencyLabels && <LabelGroup>{urgencyLabels}</LabelGroup>}
    </VerticalSpacer>
    {onShowRoomDetails && <>
      <TextLink onClick={onShowRoomDetails} size="medium">View room details</TextLink>
      <Clickable onClick={onShowRoomDetails}>
        <AccommodationRoomDetailsList roomPackage={roomPackage} />
      </Clickable>
    </>}
    {!onShowRoomDetails && <AccommodationRoomDetailsList roomPackage={roomPackage} />}
    {children}
  </StyledAccommodationSameRoomTileDetails>
}

export default AccommodationSameRoomTileDetails
